import moment from 'moment';
import React, { useEffect, useState } from "react";
import S3 from 'react-aws-s3';
import { useNavigate, useParams } from "react-router-dom";
import SignatureCanvas from 'react-signature-canvas';
import { format } from 'rut.js';
import aprobadorService from "../services/aprobador.service";
import causalService from "../services/causal.service";
import correoService from "../services/correo.service";
import documentoService from "../services/documento.service";
import emailService from "../services/email.service";
import personaService from "../services/persona.service";

import { Oval } from 'react-loader-spinner';

/** Material UI */
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import { Divider } from "@mui/material";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { SnackbarProvider, useSnackbar } from 'notistack';

/** Estilos CSS MUI */
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const Finiquito = () => {
    const initialState = {
        causal: "",
        comentarios: ""
    }
    const [causal, setCausal] = useState('');
    const [persona, setPersona] = useState('');
    const { code, id_causal } = useParams();
    const [sigPad, setSigPad] = useState({});
    const [state, setState] = useState(initialState);
    let navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [nombrearchivo, setNombreArchivo] = useState('');
    const [archivo, setArchivo] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [correos, setCorreos] = useState([]);
    const [descripcion, setDescripcion] = useState('');
    const [causal160, setCausal160] = useState([]);
    const [openModalCausal, setOpenModalCausal] = useState(false);
    const [causal1604, setCausal1604] = useState([]);
    const [openModalCausal4, setOpenModalCausal4] = useState(false);
    const [chekin, setCheckin] = useState({});
    const [getCausal, setGetCausal] = useState('');
    const [modalEvaluacion, setModalEvaluacion] = useState(false);
    const [evaluacion, setEvaluacion] = useState('');
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'));

    useEffect(async () => {
        if (!user) return navigate("/login");
        retreivePersonas();
        retreiveCorreos();
        if (id_causal) {
            var nc = await retreiveCausal(id_causal);
            setCheckin({ valor: nc.nombre });
            setCausal(nc);
            return;
            var cc = await causalService.getId(id_causal);
            setGetCausal(cc.data);
        }
    }, []);

    const openModal = () => setOpen(true);
    const closeModal = () => setOpen(false);
    const closeModalCausal = () => setOpenModalCausal(false);
    const closeModalCausal4 = () => setOpenModalCausal4(false);
    const closeModalEvaluacion = () => setModalEvaluacion(false);

    const Ingresar = () => {
        setModalEvaluacion(false);

        var desc = ingresarsDescripcion(state.causal);
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma");
            return;
        }
        if (state.causal === "") {
            alert("Por favor ingrese Causal");
            return;
        }
        setLoading(true);
        var f = sigPad.toDataURL();
        var fr = f.split(',');

        //Ingresamos la causal
        const data = {
            nombre: state.causal,
            comentario: state.comentarios,
            fecha_ingreso: Date.now(),
            rut: persona.id,
            descripcion: desc,
            evaluacion: evaluacion
        }

        causalService.ingresar(data)
            .then(async c => {
                setCausal(c.data);
                const dataap = {
                    tipo: "ADMINISTRADOR",
                    fecha: Date.now(),
                    firma: fr[1],
                    id_causal: c.data.id
                }
                aprobadorService.ingresar(dataap)
                    .then(a => {
                        console.log(a);
                    })
                    .catch(err => {
                        console.error(err);
                    });
                //Mandamos el mail
                var html = crearHTMLRRLL(new Date().toString(), c.data.nombre, c.data.id, persona);
                var crr = correos.filter(v => v.destino === "JEFERRLL");
                var send = [];
                if (crr) {
                    for (var i in crr) {
                        send.push(crr[i].correo);
                    }
                }
                const _data_mail = {
                    nombre: "JEFERRLL",
                    //from_name: "Encuesta Salud Ecora S.A.",
                    mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
                    email: send//["plagues@ecora.cl", "mlillo@ecora.cl"]//persona.perCorreo
                }
                //Envío correo a RRHH
                emailService.sendMail(_data_mail)
                    .then(response => {
                        console.log(response);
                        enqueueSnackbar('Correos enviados correctamente!', { variant: "success" });
                        personaService.update(persona.id, { estado_desv: "En Jefe de RRLL" })
                            .then(resp => {
                                console.log(resp);
                                var htmlUsuario = crearHtmlUsuario(new Date().toString(), c.data.nombre, c.data.id, persona);
                                //Envío correo a Usuario
                                if (user.user.correo === "admin@ecora.cl") {
                                    const mail_user = {
                                        nombre: "USUARIO",
                                        mensaje: htmlUsuario,
                                        email: ["jvillalobos@ecora.cl", "plagues@ecora.cl"]
                                    }
                                    emailService.sendMail(mail_user)
                                        .then(resp => {
                                            console.log("Correo Usuario ", resp);
                                        })
                                        .catch(err => {
                                            console.error("Correo usuario", err);
                                        });
                                } else {
                                    const mail_user = {
                                        nombre: "USUARIO",
                                        mensaje: htmlUsuario,
                                        email: user.correo
                                    }
                                    emailService.sendMail(mail_user)
                                        .then(resp => {
                                            console.log("Correo Usuario ", resp);
                                        })
                                        .catch(err => {
                                            console.error("Correo usuario", err);
                                        });
                                }
                            })
                            .catch(err => {
                                console.error(err);
                                enqueueSnackbar('Se ha producido un error al envíar el correo, intentelo nuevamente!', { variant: "error" });
                            });
                        setLoading(false);
                        navigate("/salida");
                        /* var html = crearHtml(new Date().toString(), c.data.nombre, c.data.id, persona);
                        var crr = correos.filter(v => v.destino === "RRHH" & v.proyecto === persona.ctoDescripcion);
                        var send = [];
                        if (crr) {
                            for (var i in crr) {
                                send.push(crr[i].correo);
                            }
                        }
                        const _data_mail = {
                            nombre: "RRHH",
                            //from_name: "Encuesta Salud Ecora S.A.",
                            mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
                            email: send//["plagues@ecora.cl", "mlillo@ecora.cl"]//persona.perCorreo
                        }
                        //Envío correo a RRHH
                        emailService.sendMail(_data_mail)
                            .then(response => {
                                console.log(response);
                                enqueueSnackbar('Correos enviados correctamente!', { variant: "success" });
                                personaService.update(persona.id, { estado_desv: "En Proceso de RRHH" })
                                    .then(resp => {
                                        console.log(resp);
                                        var htmlUsuario = crearHtmlUsuario(new Date().toString(), c.data.nombre, c.data.id, persona);
                                        //Envío correo a Usuario
                                        if (user.user.correo === "admin@ecora.cl") {
                                            const mail_user = {
                                                nombre: "USUARIO",
                                                mensaje: htmlUsuario,
                                                email: ["jvillalobos@ecora.cl", "plagues@ecora.cl"]
                                            }
                                            emailService.sendMail(mail_user)
                                                .then(resp => {
                                                    console.log("Correo Usuario ", resp);
                                                })
                                                .catch(err => {
                                                    console.error("Correo usuario", err);
                                                });
                                        } else {
                                            const mail_user = {
                                                nombre: "USUARIO",
                                                mensaje: htmlUsuario,
                                                email: user.correo
                                            }
                                            emailService.sendMail(mail_user)
                                                .then(resp => {
                                                    console.log("Correo Usuario ", resp);
                                                })
                                                .catch(err => {
                                                    console.error("Correo usuario", err);
                                                });
                                        }
                                    })
                                    .catch(err => {
                                        console.error(err);
                                    });
                                setLoading(false);
                                navigate("/salida"); */

                    })
                    .catch(e => {
                        console.log(e);
                        setLoading(false);
                        enqueueSnackbar('Error al enviar correo!', { variant: "error" });
                    });
                //}
                //setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });


        /* var html = crearHtml(new Date().toString(), state.causal, causal.id);
        const _data_mail = {
            nombre: "RRHH",
            //from_name: "Encuesta Salud Ecora S.A.",
            mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
            email: ["plagues@ecora.cl","mlillo@ecora.cl"]//persona.perCorreo
        }
        emailService.sendMail(_data_mail)
            .then(response => {
                console.log(response);
            })
            .catch(e => {
                console.log(e);
            }); */

        //setLoading(false);
        //navigate("/salida");
    }

    const handleCheck160 = (e) => {
        var arr_temp = [];
        if (e.target.checked) {
            causal160.push(e.target.value);
        } else {
            var inx = causal160.findIndex(v => v === e.target.value);
            if (inx >= 0) {
                causal160.splice(inx, 1);
            }
        }
    }

    const handleCheck1604 = (e) => {
        var arr_temp = [];
        if (e.target.checked) {
            causal1604.push(e.target.value);
        } else {
            var inx = causal1604.findIndex(v => v === e.target.value);
            if (inx >= 0) {
                causal1604.splice(inx, 1);
            }
        }
    }

    function ingresarsDescripcion(valor) {
        var desc = "";
        if (valor === "Art 159 N1") {
            desc = "Art 159 N°1 Mutuo acuerdo de las partes.";
            return desc;
            //setDescripcion("Art 159 N°1 Mutuo acuerdo de las partes.");
        }
        if (valor === "Art 159 N2") {
            desc = "Art 159 N°2 Renuncia del trabajador, dando aviso a su empleador con treinta días de anticipación, a lo menos.";
            return desc;
            //setDescripcion("Art 159 N°2 Renuncia del trabajador, dando aviso a su empleador con treinta días de anticipación, a lo menos.");
        }
        if (valor === "Art 159 N3") {
            desc = "Art 159 N°3 Muerte del trabajador.";
            return desc;
            //setDescripcion("Art 159 N°3 Muerte del trabajador.");
        }
        if (valor === "Art 159 N4") {
            desc = "Art 159 N°4 Vencimiento del plazo convenido en el contrato. La duración del contrato de plazo fijo no podrá exceder de un año.";
            return desc;
            //setDescripcion("Art 159 N°4 Vencimiento del plazo convenido en el contrato. La duración del contrato de plazo fijo no podrá exceder de un año.");
        }
        if (valor === "Art 159 N5") {
            desc = "Art 159 N°5 Conclusión del trabajo o servicio que dio origen al contrato.";
            return desc;
            //setDescripcion("Art 159 N°5 Conclusión del trabajo o servicio que dio origen al contrato.");
        }
        if (valor === "Art 159 N6") {
            desc = "Art 159 N°6 Caso fortuito o fuerza mayor.";
            return desc;
            //setDescripcion("Art 159 N°6 Caso fortuito o fuerza mayor.");
        }
        if (valor === "Art 160 N1") {
            var text = "Art 160 N°1 Alguna de las conductas indebidas de carácter grave, debidamente comprobadas, que a continuación se señalan: ";
            for (var i in causal160) {
                text = text + causal160[i] + "; ";
            }
            desc = text;
            return desc;
            //setDescripcion(text);
        }
        if (valor === "Art 160 N2") {
            desc = "Art 160 N°2 Negociaciones que ejecute el trabajador dentro del giro del negocio y que hubieren sido prohibidas por escrito en el respectivo contrato por el empleador.";
            return desc;
        }
        if (valor === "Art 160 N3") {
            desc = "Art 160 N°3 No concurrencia del trabajador a sus labores sin causa justificada durante dos días seguidos, dos lunes en el mes, o un total de tres días en el mes.";
            return desc;
        }
        if (valor === "Art 160 N4") {
            //desc = "Art 160 N°4 Abandono del trabajo y/o negativa a trabajar sin causa justificada.";
            var text = "Art N°4 Abandono del trabajo por parte del trabajador, entendiéndose por tal: ";
            for (var i in causal1604) {
                text = text + causal1604[i] + "; ";
            }
            desc = text;
            return desc;
        }
        if (valor === "Art 160 N5") {
            desc = "Art 160 N°5 Actos, omisiones o imprudencias temerarias que afecten a la seguridad o al funcionamiento del establecimiento, a la seguridad o a la actividad de los trabajadores, o a la salud de éstos.";
            return desc;
        }
        if (valor === "Art 160 N6") {
            desc = "Art 160 N°6 El perjuicio material causado intencionalmente en las instalaciones, maquinarias, herramientas, útiles de trabajo, productos o mercaderías.";
            return desc;
        }
        if (valor === "Art 160 N7") {
            desc = "Art 160 N°7 Incumplimiento grave de las obligaciones que impone el contrato.";
            return desc;
        }
        if (valor === "Art 161 N1") {
            desc = "Art 161 N°1 Necesidades de la Empresa.";
            return desc;
        }
        if (valor === "Art 161 N2") {
            desc = "Art 161 inciso 2 Desahucio escrito del empleador.";
            return desc;
        }
    }

    const guardarDocumento = async () => {
        if (!nombrearchivo) {
            enqueueSnackbar('Falta nombre de archivo!', { variant: "error" });
            return;
        }
        if (!archivo) {
            enqueueSnackbar('Falta adjuntar archivo!', { variant: "error" });
            return;
        }
        if (!persona) {
            enqueueSnackbar('Debe buscar a la Persona!', { variant: "error" });
            return;
        }
        setLoading(true);
        //Guardamos documento en S3 AWS
        var dir = persona.Rut.replace(/\./g, '');
        const config = {
            bucketName: 'docreclutav2',
            dirName: dir + "/hojavida",
            acl: 'public-read',
            //dirName: 'photos', /* optional */
            region: 'sa-east-1',
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY
        }
        const ReactS3Client = new S3(config);
        var extension = archivo[0].name.split('.').pop();
        var ruta = "";
        window.Buffer = window.Buffer || require("buffer").Buffer;
        let doc = await ReactS3Client.uploadFile(archivo[0], nombrearchivo + "." + extension);
        if (doc) {
            ruta = doc.location;
        } else {
            enqueueSnackbar('Ocurrio un problema al subir el Archivo!', { variant: "error" });
            return;
        }

        //Ingresamos el documento
        documentoService.ingresar({ nombre: nombrearchivo, personaId: persona.id, ruta: ruta })
            .then(resp => {
                console.log(resp);
                setLoading(false);
                enqueueSnackbar('Archivo subido correctamente!', { variant: "success" });
                setArchivo('');
                setNombreArchivo('');
                retreivePersonaXRut();
                closeModal();
                //window.location.reload();
            })
            .catch(err => {
                console.error(err);
            });
        /* setArchivo('');
        setNombreArchivo('');
        retreivePersonaXRut();
        closeModal();
        window.location.reload(); */
    }

    const retreivePersonaXRut = () => {
        personaService.getPorRut(code)
            .then(persona => {
                setPersona(persona.data[0]);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const onChangeCausal = (e) => {
        const dato = e.target.value;
        setCausal(dato);
    }

    const handleChangeText = (value, name) => {
        if (value.target.value === "Art 159 N1") {
            setNombreArchivo("ACUERDO_PARTES");
            var doc = persona.documento.find(v => v.nombre === "ACUERDO_PARTES");
            if (doc) {
                setState({ ...state, [name]: value.target.value });
                setCheckin({ valor: value.target.value });
            } else {
                alert("Se requiere subir el documento para seguir con desvinculación");
                value.target.checked = false;
                setOpen(true);
            }
        } else if (value.target.value === "Art 159 N2") {
            setNombreArchivo("RENUNCIA_TRABAJADOR");
            var doc = persona.documento.find(v => v.nombre === "RENUNCIA_TRABAJADOR");
            if (doc) {
                setState({ ...state, [name]: value.target.value });
                setCheckin({ valor: value.target.value });
            } else {
                alert("Se requiere subir el documento para seguir con desvinculación");
                value.target.checked = false;
                setOpen(true);
            }
        } else if (value.target.value === "Art 160 N3") {
            setNombreArchivo("AVISO_DT_NO_CONCURRENCIA");
            var doc = persona.documento.find(v => v.nombre === "AVISO_DT_NO_CONCURRENCIA");
            if (doc) {
                setState({ ...state, [name]: value.target.value });
                setCheckin({ valor: value.target.value });
            } else {
                alert("Se requiere subir el documento para seguir con desvinculación");
                value.target.checked = false;
                setOpen(true);
            }
        } else if (value.target.value === "Art 160 N4") {
            setNombreArchivo("AVISO_DT_ABANDONO");
            var doc = persona.documento.find(v => v.nombre === "AVISO_DT_ABANDONO");
            if (doc) {
                setState({ ...state, [name]: value.target.value });
                setCheckin({ valor: value.target.value });
                setOpenModalCausal4(true);
            } else {
                alert("Se requiere subir el documento para seguir con desvinculación");
                value.target.checked = false;
                setOpen(true);
            }
        } else if (value.target.value === "Art 160 N7") {
            setNombreArchivo("INCUMPLIMIENTO_GRAVE");
            var doc = persona.documento.find(v => v.nombre === "INCUMPLIMIENTO_GRAVE");
            if (doc) {
                setState({ ...state, [name]: value.target.value });
                setCheckin({ valor: value.target.value });
            } else {
                alert("Se requiere subir el documento para seguir con desvinculación");
                value.target.checked = false;
                setOpen(true);
            }
        } else if (value.target.value === "Art 160 N1") {
            setNombreArchivo("CONDUCTAS_INDEVIDAS");
            var doc = persona.documento.find(v => v.nombre === "CONDUCTAS_INDEVIDAS");
            if (doc) {
                setState({ ...state, [name]: value.target.value });
                setCheckin({ valor: value.target.value });
                setOpenModalCausal(true);
            } else {
                alert("Se requiere subir documento para seguir con desvinculación");
                value.target.checked = false;
                setOpen(true);
            }
        } else if (value.target.value === "Art 160 N5") {
            setNombreArchivo("ACTOS_OMISIONES");
            var doc = persona.documento.find(v => v.nombre === "ACTOS_OMISIONES");
            if (doc) {
                setState({ ...state, [name]: value.target.value });
                setCheckin({ valor: value.target.value });
            } else {
                alert("Se requiere subir documento para seguir con desvinculación");
                value.target.checked = false;
                setOpen(true);
            }
        } else {
            setState({ ...state, [name]: value.target.value });
            if (name !== "comentarios") {
                setCheckin({ valor: value.target.value });
            }

        }
    };

    async function retreiveCausal(id_causal) {
        let c = await causalService.getId(id_causal);
        if (c) {
            return c.data;
        }
    }

    const checkedForm = (valor) => {
        var status = false;
        if (valor === "Art 159 N1") {
            status = true;
        }
        if (valor === "Art 160 N2") {
            status = true;
        }
        return status;
    }

    function checked(valor) {
        if (valor === "Art 160 N1") {
            setCheckin({ valor: true });
        }
    }

    const retreivePersonas = () => {
        personaService.getPorRut(format(code))
            .then(response => {
                setPersona(response.data[0]);
            })
            .catch(e => {
                console.log(e);
            });
    };

    function retreiveCorreos() {
        correoService.getAll()
            .then(resp => {
                setCorreos(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const limpiarFirma = () => {
        sigPad.clear();
    }

    function crearHtmlGerencia(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita su aprobación a traves del siguiente link: </p> <a href='${baseurl}/finiquitoger/${id_causal}'>${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno}</a> \n <p>con Causal: ${causal} </p>`;
        html = html + "</div>";
        return html;
    }

    function crearHtml(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita completar a traves del siguiente link: </p> <a href='${baseurl}/finiquitopt2/${id_causal}'>${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno}</a> \n <p>con Causal: ${causal} </p>`;
        html = html + "</div>";
        return html;
    }

    function crearHTMLRRLL(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita completar a traves del siguiente link: </p> <a href='${baseurl}/finiquitorrll/${id_causal}'>${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno}</a> \n <p>con Causal: ${causal} </p>`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlUsuario(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la persona: ${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno}</a> \n <p>con Causal: ${causal} </p>`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlMutuoAcuerdo(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Desvinculación de Mutuo Acuerdo</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita completar información a traves del siguiente link: </p> <a href="${baseurl}/finiquito3/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    const actualizar = () => {
        var desc = ingresarsDescripcion(state.causal);
        causalService.update(id_causal, { nombre: state.causal, descripcion: desc, comentario: state.comentarios })
            .then(resp => {
                console.log(resp);
                enqueueSnackbar("Actualizdo Correctamente!!", { variant: 'success' });
            })
            .catch(err => {
                console.error(err);
            })
    }

    return (
        loading ? (
            <div>
                <div className="d-flex justify-content-center">
                    <Oval
                        heigth="100"
                        width="100"
                        color='blue'
                        ariaLabel='loading'
                    />
                </div>
                <p className="text-center">Cargando ...</p>
            </div>
        ) : (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="text-center">
                            <h2>Datos de Trabajador</h2>
                        </div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>Rut:</td>
                                    <td>{persona.Rut}</td>
                                </tr>
                                <tr>
                                    <td>Nombre</td>
                                    <td>{persona ? persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno : ""}</td>
                                </tr>
                                <tr>
                                    <td>Unidad de Negocio:</td>
                                    <td>{persona.ctoDescripcion}</td>
                                </tr>
                                <tr>
                                    <td>Cargo:</td>
                                    <td>{persona.recDescripcion}</td>
                                </tr>
                                <tr>
                                    <td>Fecha Ingreso:</td>
                                    <td>{persona ? moment(persona.FechaContratoInicial).local().format('DD/MM/YYYY') : ""}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-auto">
                        <h2>Causal de Despido</h2>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 159 N1" id="flexCheckDefault1" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 159 N1" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault1">
                                Art 159 N°1 Mutuo acuerdo de las partes.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 159 N2" id="flexCheckDefault2" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 159 N2" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault2">
                                Art 159 N°2 Renuncia del trabajador.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 159 N3" id="flexCheckDefault3" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 159 N3" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault3">
                                Art 159 N°3 Muerte del trabajador.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 159 N4" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 159 N4" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 159 N°4 Vencimiento del plazo convenido en el contrato.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 159 N5" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 159 N5" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 159 N°5 Conclusión del trabajo o servicio que dio origen al contrato.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 159 N6" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 159 N6" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 159 N°6 Caso fortuito o fuerza mayor.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 160 N1" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 160 N1" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 160 N°1 Conductas indebidas, falta de probidad, Vías de hecho, Injurias, Conducta inmoral, negociaciones que ejecute el trabajador dentro del giro del negocio de la empresa
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 160 N2" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 160 N2" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 160 N°2 Negociaciones que ejecute el trabajador dentro del giro del negocio y que hubieren sido prohibidas por escrito en el respectivo contrato por el empleador.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 160 N3" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 160 N3" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 160 N°3 No concurrencia del trabajador a sus labores sin causa justificada durante dos días seguidos, dos lunes en el mes, o un total de tres días en el mes.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 160 N4" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 160 N4" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 160 N°4 Abandono del trabajo y/o negativa a trabajar sin causa justificada
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 160 N5" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 160 N5" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 160 N°5 Actos, omisiones o imprudencias temerarias que afecten a la seguridad o al funcionamiento del establecimiento, a la seguridad o a la actividad de los trabajadores, o a la salud de éstos.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 160 N6" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 160 N6" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 160 N°6 El perjuicio material causado intencionalmente en las instalaciones, maquinarias, herramientas, útiles de trabajo, productos o mercaderías.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 160 N7" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 160 N7" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 160 N°7 Incumplimiento grave de las obligaciones que impone el contrato. Incumplimientos, fallas, etc.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 161 N1" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 161 N1" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 161 N°1 Necesidades de la Empresa.
                            </label>
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="causal" value="Art 161 N2" id="flexCheckDefault" onChange={(e) => handleChangeText(e, "causal")} checked={chekin["valor"] === "Art 161 N2" ? true : false} />
                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                Art 161 N°2 Desahucio escrito del empleador.
                            </label>
                        </div>
                        <div className="input-group p-2">
                            <span className="input-group-text">Comentarios:</span>
                            <textarea placeholder="Ingresar comentarios ..." className="form-control" aria-label="With textarea" name="comentarios" onChange={(e) => handleChangeText(e, "comentarios")}></textarea>
                        </div>
                        <div className="mb-3">
                            <div className="form-label">Ingresar Firma:</div>
                            <SignatureCanvas
                                canvasProps={{
                                    className: "sginatureCanvas"
                                }}
                                ref={(ref) => { setSigPad(ref) }}
                            />
                        </div>
                        <div className="bd-example">
                            {id_causal ? (
                                <button className="btn btn-success" onClick={actualizar}>Actualizar</button>
                            ) : (
                                <button className="btn btn-primary" onClick={() => setModalEvaluacion(true)}>Ingresar</button>
                            )}
                            <button className="btn btn-secondary" onClick={limpiarFirma}>Limpiar Firma</button>
                        </div>
                    </div>
                </div>
                <Modal
                    open={open}
                    onClose={closeModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" align="center" style={{ marginBottom: 10 }}>
                            Subir Documento
                        </Typography>
                        <Stack spacing={2} direction="row">
                            <TextField
                                label="Nombre Documento"
                                value={nombrearchivo}
                                onChange={(e) => setNombreArchivo(e.target.value)}
                                disabled
                            />
                            <Button variant="contained" component="label">
                                Subir
                                <input hidden /* accept="image/*" */ multiple type="file" onChange={(e) => setArchivo(e.target.files)} />
                            </Button>
                            <LoadingButton
                                color="secondary"
                                //onClick={handleClick}
                                //loading={loading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="contained"
                                onClick={guardarDocumento}
                            >
                                Guardar
                            </LoadingButton>
                        </Stack>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Ingeso de documento a la hoja de vida del trabajador.
                        </Typography>
                    </Box>
                </Modal>
                {/** Modal eleccion de causal 160 */}
                <Modal
                    open={openModalCausal}
                    onClose={closeModalCausal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" align="center" style={{ marginBottom: 10 }}>
                            Seleccionar Letra Causal
                        </Typography>
                        <Stack spacing={2} direction="column">
                            <FormGroup>
                                <FormControlLabel control={<Checkbox value="a) Falta de probidad del trabajador en el desempeño de sus funciones" onChange={(e) => handleCheck160(e)} />} label="a) Falta de probidad del trabajador en el desempeño de sus funciones" />
                                <FormControlLabel control={<Checkbox value="b)  Conductas de acoso sexual" onChange={(e) => handleCheck160(e)} />} label="b)  Conductas de acoso sexual" />
                                <FormControlLabel control={<Checkbox value="c)  Vías de hecho ejercidas por el trabajador en contra del empleador o de cualquier trabajador que se desempeñe en la misma empresa" onChange={(e) => handleCheck160(e)} />} label="c)  Vías de hecho ejercidas por el trabajador en contra del empleador o de cualquier trabajador que se desempeñe en la misma empresa" />
                                <FormControlLabel control={<Checkbox value="d)  Injurias proferidas por el trabajador al empleador" onChange={(e) => handleCheck160(e)} />} label="d)  Injurias proferidas por el trabajador al empleador" />
                                <FormControlLabel control={<Checkbox value="e)  Conducta inmoral del trabajador que afecte a la empresa donde se desempeña" onChange={(e) => handleCheck160(e)} />} label="e)  Conducta inmoral del trabajador que afecte a la empresa donde se desempeña" />
                                <FormControlLabel control={<Checkbox value="f)  Conductas de acoso laboral." onChange={(e) => handleCheck160(e)} />} label="f)  Conductas de acoso laboral." />
                            </FormGroup>
                        </Stack>
                        <Button variant="contained" component="label" onClick={closeModalCausal}>
                            Seleccionar
                        </Button>
                    </Box>
                </Modal>
                <Modal
                    open={openModalCausal4}
                    onClose={closeModalCausal4}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" align="center" style={{ marginBottom: 10 }}>
                            Seleccionar Letra Causal
                        </Typography>
                        <Stack spacing={2} direction="column">
                            <FormGroup>
                                <FormControlLabel control={<Checkbox value="a)  La salida intempestiva e injustificada del trabajador del sitio de la faena y durante las horas de trabajo, sin permiso del empleador o de quien lo represente" onChange={(e) => handleCheck1604(e)} />} label="a)  La salida intempestiva e injustificada del trabajador del sitio de la faena y durante las horas de trabajo, sin permiso del empleador o de quien lo represente" />
                                <FormControlLabel control={<Checkbox value="b)  La negativa a trabajar sin causa justificada en las faenas convenidas en el contrato" onChange={(e) => handleCheck1604(e)} />} label="b)  La negativa a trabajar sin causa justificada en las faenas convenidas en el contrato" />
                            </FormGroup>
                        </Stack>
                        <Button variant="contained" component="label" onClick={closeModalCausal4}>
                            Seleccionar
                        </Button>
                    </Box>
                </Modal>
                <Modal
                    open={modalEvaluacion}
                    onClose={closeModalEvaluacion}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" align="center" style={{ marginBottom: 10 }}>
                            Evaluar a trabajador
                        </Typography>
                        <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">Evaluación</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="female"
                                name="radio-buttons-group"
                            >
                                <FormControlLabel value="No cumple con los requerimientos del cargo" control={<Radio onChange={(e) => setEvaluacion(e.target.value)} />} label="No cumple con los requerimientos del cargo" />
                                {/* <FormControlLabel value="No cumple con los requerimientos del cargo, pero puede ser reubicado" control={<Radio onChange={(e) => setEvaluacion(e.target.value)} />} label="No cumple con los requerimientos del cargo, pero puede ser reubicado" /> */}
                                {/* <FormControlLabel value="Necesita mejoras o reubicación en funciones distintas" control={<Radio onChange={(e) => setEvaluacion(e.target.value)} />} label="Necesita mejoras o reubicación en funciones distintas" /> */}
                                <FormControlLabel value="Cumple con los requisitos del cargo" control={<Radio onChange={(e) => setEvaluacion(e.target.value)} />} label="Cumple con los requisitos del cargo" />
                                {/* <FormControlLabel value="Supera los requisitos del cargo" control={<Radio onChange={(e) => setEvaluacion(e.target.value)} />} label="Supera los requisitos del cargo" /> */}
                                <FormControlLabel value="No cumple por conducta o comportamiento" control={<Radio onChange={(e) => setEvaluacion(e.target.value)} />} label="No cumple por conducta o comportamiento" />
                                {/* <FormControlLabel value="Se recomienda promoción a cargo superior" control={<Radio onChange={(e) => setEvaluacion(e.target.value)} />} label="Se recomienda promoción a cargo superior" /> */}
                            </RadioGroup>
                        </FormControl>
                        <Divider mt={3}></Divider>
                        <Box
                            style={{
                                marginTop: 3,
                                alignItems: 'end',
                                justifyContent: 'end'
                            }}
                        >
                            <Button variant="contained" onClick={Ingresar}>Ingresar</Button>
                        </Box>
                    </Box>
                </Modal>
            </div>
        )
    );
};

export default function FiniquitoNotistack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <Finiquito />
        </SnackbarProvider>
    );
}